<app-rounded-hover-box [border]="true">
  <div
    class="layout width-{{ theme().section.width }} {{ theme().section.grid_layout }}"
    [style.--layout-gap]="theme().section.spacing / 2 + 'px'"
  >
    @for (row of rows(); track $index) {
      <div class="row">
        @for (asset of row; track $index) {
          <div class="asset {{ asset }}"></div>
        }
      </div>
    }
  </div>
</app-rounded-hover-box>
